<div class="title-bar no-container-margin">
  <span class="bread-crumb-head">{{assetCollection?.name ?? 'Asset Collection'}}</span>
</div>
@if (invalidLink) {
  <p class="alert alert-danger w-100 h-100">
    {{'i18n.domain.assets.asset-collections.public-view.messages.invalid-link' | translate}}
  </p>
}
@if (noAssets) {
  <p class="alert alert-warning w-100 h-100">
    {{'i18n.domain.assets.asset-collections.public-view.messages.no-assets' | translate}}
  </p>
}
<!-- hidden search bar: to unhide -> remove cssClass and remove file-manager-hide-search class in styles.scss -->
@if (assetCollection?.fileData?.files?.length > 0) {
  <ejs-filemanager id='overview' allowDragAndDrop="false"
    height="90vh" [navigationPaneSettings]="navigationPaneSettings" [toolbarSettings]="toolbarSettings"
    [contextMenuSettings]="contextMenuSettings" (fileOpen)="onFileOpen($event)" [fileSystemData]="fileSystemData"
    [ajaxSettings]='ajaxSettings' (beforeImageLoad)="beforeImageLoad($event)" (beforeDownload)="beforeDownload($event)"
    (beforeSend)="beforeSend($event)">
  </ejs-filemanager>
}